module.exports = __webpack_public_path__ + "img/close-icon.8cab8269.svg";